var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconRemove = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 13,
  viewBox: "0 0 12 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_138_18616)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.57093 9.43525L3.32829 5.19261C2.93938 4.8037 2.93938 4.1673 3.32829 3.7784C3.7172 3.38949 4.3536 3.38949 4.74251 3.7784L8.98515 8.02104C9.37406 8.40995 9.37406 9.04634 8.98515 9.43525C8.59624 9.82416 7.95984 9.82416 7.57093 9.43525Z",
  fill: "#1160FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.32833 9.43525C2.93942 9.04634 2.93942 8.40995 3.32833 8.02104L7.57097 3.7784C7.95988 3.38949 8.59627 3.38949 8.98518 3.7784C9.37409 4.1673 9.37409 4.8037 8.98518 5.19261L4.74254 9.43525C4.35363 9.82416 3.71724 9.82416 3.32833 9.43525Z",
  fill: "#1160FF"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_138_18616"
}, /*#__PURE__*/React.createElement("rect", {
  width: 8,
  height: 8,
  fill: "white",
  transform: "translate(6.15674 0.950195) rotate(45)"
})))));
export default SvgIconRemove;